import { useRef ,useState} from "react";
import { FiCamera } from "react-icons/fi";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import styles from "./Imagepopup.module.css";

const HomeImagePopup = ({ isOpen, onClose }) => {
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
const [loading, setLoading] = useState(false);
const handleImageUpload = async (e) => {
  const file = e.target.files?.[0];

  if (!file) return;

  try {
    setLoading(true);

    const formData = new FormData();

    formData.append("file", file);
    formData.append(
      "apikey",
      process.env.REACT_APP_OCR_SPACE_API_KEY
    );

    formData.append("language", "eng");
    formData.append("OCREngine", "2");
    formData.append("scale", "true");

    const response = await axios.post(
      "https://api.ocr.space/parse/image",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const text =
      response.data?.ParsedResults?.[0]?.ParsedText || "";

    const extractedItems = text
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 2);

    navigate("/shopping-list", {
      state: {
        extractedItems,
      },
    });

    onClose();
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <button
          className={styles.closeBtn}
          onClick={onClose}
        >
          ✕
        </button>

        <h2>Have a  Prescription?</h2>

        <p>
        Find your Medicines in one go
        </p>

      <button
  className={styles.uploadBtn}
  onClick={() => fileInputRef.current?.click()}
  disabled={loading}
>
  {loading ? (
    <>
      <span className={styles.spinner}></span>
      Reading Prescription...
    </>
  ) : (
    <>
      <FiCamera size={20} />
      Upload Prescription
    </>
  )}
</button>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleImageUpload}
        />
      </div>
    </div>
  );
};

export default HomeImagePopup;